import { makeStyles, shorthands } from '@fluentui/react-components';

export const getImageShimmerStyles = makeStyles({
  imageShimmerRoot: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    ...shorthands.overflow('hidden'),
    backgroundSize: '400% 100%',
    animationDuration: '1.5s',
    animationTimingFunction: 'ease-in-out',
    animationDirection: 'alternate',
    animationIterationCount: 'infinite',
    animationName: [{
      from: { backgroundPosition: '0%' },
      to: { backgroundPosition: '100%' },
    }],
  },
});

